import {AuthService} from '@/core/services/AuthService.js';

const POLL_INTERVAL_MS = 5000;

export class OpSessionService {
    static instance;
    #opIframe = null;
    #timerId = null;
    #onStatusChange = null;
    #opOrigin = new URL(import.meta.env.VITE_APP_BUSSOLA_URL).origin;
    #opIframeUrl = `${import.meta.env.VITE_APP_BUSSOLA_URL}/educador/check_session_iframe`;
    #messageHandler = null;

    static getInstance() {
        if (!OpSessionService.instance) {
            OpSessionService.instance = new OpSessionService();
        }
        return OpSessionService.instance;
    }

    get opIframeUrl() {
        return this.#opIframeUrl;
    }

    bindOpIframe(element) {
        this.#opIframe = element;
    }

    start(onStatusChange) {
        if (this.#timerId) {
            return;
        }
        this.#onStatusChange = onStatusChange;
        this.#messageHandler = (event) => this.#handleMessage(event);
        window.addEventListener('message', this.#messageHandler);
        this.#timerId = setInterval(() => this.checkSession(), POLL_INTERVAL_MS);
    }

    checkSession() {
        if (!this.#opIframe?.contentWindow) {
            return;
        }
        this.#opIframe.contentWindow.postMessage('check', this.#opOrigin);
    }

    #handleMessage(event) {
        if (event.origin !== this.#opOrigin) {
            return;
        }

        if (event.source !== this.#opIframe?.contentWindow) {
            return;
        }

        let payload;
        try {
            payload = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        } catch {
            return;
        }

        if (!payload || typeof payload !== 'object') {
            return;
        }

        if (this.#onStatusChange) {
            this.#onStatusChange(payload);
        }

        if (payload.loggedIn === false && AuthService.getInstance().isAuthenticated()) {
            AuthService.getInstance().logout();
        }
    }
}
